import '../scss/main.scss';
var graphic_url_path = window.GRAPHIC_URL_PATH || ''; //IMPORT the main HTML

import article from './article.ejs';
import article_sm from './article_sm.ejs';
var mobile_onload = window.innerWidth < 600 ? true : false;

function placeImage() {
  var mobile = window.innerWidth < 600 ? true : false;
  var el = document.getElementsByClassName('masthead-image');
  var els = document.querySelectorAll('.masthead-image');
  [].forEach.call(els, function (el) {
    if (mobile) {
      el.innerHTML = article_sm({
        graphic_url_path: graphic_url_path
      });
    } else {
      el.innerHTML = article({
        graphic_url_path: graphic_url_path
      });
    }
  });
}

placeImage();
window.addEventListener('resize', function () {
  var mobile = window.innerWidth < 600 ? true : false;

  if (mobile != mobile_onload) {
    mobile_onload = mobile;
    placeImage();
  }
});